module.exports = __webpack_public_path__ + "images/lamborghini_smalldd9ccb4ae70405a5c05458c5b1dc71c9.png";